module.exports = __webpack_public_path__ + "media/images/logo-76164d1d1359bfa7091d07add98417fc.svg";